import React from "react";
import PropTypes from "prop-types";
import styles from "./StudentListTableHeader.module.css";
import InformationPopup from "components/InformationPopup";

const StudentListTableHeader = ({ isChecked, onSelectAll, view }) => {
  if (view === "cpnw") {
    return (
      <div className={`${styles.container} ${styles.cpnwContainer}`}>
        <div className={styles.cpnwNameColumn}>
          <span className={styles.studentNameText}>First, Last</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span className={styles.columnText}>Middle Initial</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span className={styles.columnText}>Date of Birth</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span className={styles.columnText}>Program</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span className={styles.columnText}>School</span>
        </div>
        <div className={styles.cpnwColumn}>
          <span className={styles.columnText}>Approvals</span>
        </div>
      </div>
    );
  }

  // Default background view
  return (
    <div className={styles.container}>
      <div className={styles.checkboxContainer}>
        <div className={styles.tooltipWrapper}>
          <input
            type="checkbox"
            className={`${styles.checkbox} ${isChecked ? styles.checked : ""}`}
            onChange={(e) => onSelectAll(e.target.checked)}
            checked={isChecked}
          />
        </div>
      </div>
      <div className={styles.studentNameContainer}>
        <span className={styles.studentNameText}>Student Name</span>
      </div>
      <div className={styles.firstCategoryHeaderContainer}>
        <span className={styles.firstCategoryHeaderText}>
          Checkr Background Check
        </span>
      </div>
      <div className={styles.firstCategoryHeaderContainer}>
        <span className={styles.firstCategoryHeaderText}>Modified On</span>
      </div>
      <div className={styles.statusContainer}>
        <span className={styles.statusText}>Status</span>
      </div>
      <div className={styles.secondCategoryHeaderContainer}>
        <span className={styles.secondCategoryHeaderText}>
          CPNW WATCH Report
        </span>
      </div>
      <div className={styles.secondCategoryHeaderContainer}>
        <span className={styles.secondCategoryHeaderText}>Modified On</span>
      </div>
      <div className={styles.statusContainer}>
        <span className={styles.statusText}>Status</span>
      </div>
    </div>
  );
};

StudentListTableHeader.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onSelectAll: PropTypes.func.isRequired,
  view: PropTypes.oneOf(["background", "cpnw"]),
};

export default StudentListTableHeader;